// Environment Detection
export const IS_ALFAJR = process.env.REACT_APP_APP_ID === 'alfajr' || process.env.REACT_APP_ID === 'alfajr';

// Order Status Constants
export const ORDER_STATUS = {
  PENDING: "pending",
  CONFIRMED: "confirmed",
  ON_DELIVERY: "on delivery",
  DELIVERED: "delivered",
  CANCELLED: "cancelled",
};

// Helper to get display label for status
export const getStatusLabel = (status) => {
  return status.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
};
